import api from '../../services/api';
import moment from 'moment';
import * as type from '../types';

export default {
    namespaced: true,
    state: {
        headers: [
            {
                type: 'expand'
            },
            {
                text: 'Date Processed',
                value: 'dateProcessed',
                sortable: true,
                width: '150'
            },
            {
                text: 'Brand',
                value: 'brandName',
                sortable: true,
                width: '150'
            },
            {
                text: 'Segment',
                value: 'segment',
                sortable: true,
                width: '150'
            },
            {
                text: 'PO #',
                value: 'purchaseOrderNumber',
                sortable: true,
                width: '150'
            },
            {
                text: 'Invoice #',
                value: 'invoiceNumber',
                sortable: true,
                width: '150'
            },
            {
                text: 'Invoice Date',
                value: 'invoiceDate',
                sortable: true,
                width: '150'
            },
            {
                text: 'Qty Ordered',
                value: 'totalQtyOrdered',
                sortable: true,
                width: '150'
            },
            {
                text: 'Qty Shipped',        
                value: 'totaQtyShipped',
                sortable: true,
                width: '150'
            },
            {
                text: 'Total Cost',
                value: 'totalCost',
                sortable: true,
                width: '150'
            },
            {
                text: 'Actions',
                fixed: 'right',
                width: '100',
                align: 'center',
                alignHeader: 'center'
            }
        ],
        records: [],
        brandRecords: [],
        segmentRecords: [],
        userRecords: []
    },
    getters: {
        getHeaders: state => state.headers,
        getRecords: state => state.records,

        getBrandRecords: state => state.brandRecords,
        getSegmentRecords: state => state.segmentRecords,
        getUserRecords: state => state.userRecords
    },
    mutations: {
        [type.GET_INVOICE_RECORDS]: (state, payload) => state.records = payload,
        [type.GET_BRAND_RECORDS]: (state, payload) => state.brandRecords = payload,
        [type.GET_SEGMENT_RECORDS]: (state, payload) => state.segmentRecords = payload,
        [type.GET_USER_RECORDS]: (state, payload) => state.userRecords = payload,
    },
    actions: {
        [type.GET_BRAND_RECORDS]: async ({commit}) => {
            commit(type.GET_BRAND_RECORDS, []);
            try {
                let response = await api.get('/get/invoice-information');
                if(response.status == 200){
                    let result = response.data.map(e => {
                        return e.brandName
                    });
                    commit(type.GET_BRAND_RECORDS, [...new Set(result)]);
                }
            } catch (error) {
                commit(type.GET_BRAND_RECORDS, []);
            }
        },
        [type.GET_SEGMENT_RECORDS]: async ({commit}) => {
            commit(type.GET_SEGMENT_RECORDS, []);
            try {
                let response = await api.get('/get/invoice-information');
                if(response.status == 200){
                    let result = response.data.map(e => {
                        return e.segment
                    });
                    commit(type.GET_SEGMENT_RECORDS, [...new Set(result)]);
                }
            } catch (error) {
                commit(type.GET_SEGMENT_RECORDS, []);
            }
        },
        [type.GET_USER_RECORDS]: async ({commit}) => {
            commit(type.GET_USER_RECORDS, []);
            try {
                let response = await api.get('/get/invoice-information');
                if(response.status == 200){
                    let result = response.data.map(e => {
                        return e.firstName
                    });
                    commit(type.GET_USER_RECORDS, [...new Set(result)]);
                }
            } catch (error) {
                commit(type.GET_USER_RECORDS, []);
            }
        },
        [type.GET_INVOICE_RECORDS]: async ({commit}, payload) => {
            commit(`global/${type.SET_LOADING}`, null, { root: true });
            commit(type.GET_INVOICE_RECORDS, []);

            const { startDate, endDate, brandName, segment, firstName, invoiceType } = payload;
            let query = '';
            if(startDate && endDate){
                query = query ? `${query}&startDate=${startDate}&endDate=${endDate}` : `startDate=${startDate}&endDate=${endDate}` 
            }
            if(brandName){
                query = query ? `${query}&brandName=${brandName}` : `brandName=${brandName}`
            }
            if(segment){
                query = query ? `${query}&segment=${segment}` : `segment=${segment}`
            }
            if(firstName){
                query = query ? `${query}&firstName=${firstName}` : `firstName=${firstName}`
            }
            if(invoiceType){
                query = query ? `${query}&type=${invoiceType}` : `type=${invoiceType}`
            }
            try {
                let response = await api.get(`/get/invoice-information?${query}`);
                
                if(response.status === 200){
                    let result = response.data.map(e => {
                        let dateProcessed = moment(e.dateProcessed).utcOffset('+08:00').format('MM/DD/YYYY');
                        let dropShipFee = e.dropShipFee === undefined ? '' : e.dropShipFee;
                        let type = e.type === 'fileFeed' ? 'Template' : e.type
                        return {
                            ...e,
                            dateProcessed,
                            dropShipFee,
                            type
                        }
                    });
                    commit(type.GET_INVOICE_RECORDS, result);
                }
            } catch (error) {
                commit(type.GET_INVOICE_RECORDS, []);
                commit(`global/${type.SET_MESSAGE}`, { type: 'error', message: error.data.err.msg }, { root: true });
            }finally{
                commit(`global/${type.REMOVE_LOADING}`, null, { root: true })
            }
        }
    }
}